interface UserType {
  readonly value: number;
  readonly name: string;
  readonly label: string;
}

export const CANDIDATE_USER_TYPE = {
  value: 0,
  name: "candidate",
  label: "Candidate",
} as const satisfies UserType;

export const userTypes = [
  CANDIDATE_USER_TYPE,
  { value: 10, name: "school_user", label: "School User" },
  { value: 20, name: "school_admin", label: "School Admin" },
  { value: 30, name: "district_user", label: "District User" },
  { value: 40, name: "district_admin", label: "District Admin" },
  { value: 50, name: "super_admin", label: "Super Admin" },
] as const satisfies readonly UserType[];

export function getUserType(value: number | undefined): UserType | undefined {
  return userTypes.find((t) => t.value === value);
}
